export var Quantity;
(function (Quantity) {
    Quantity["MANY"] = "many";
    Quantity["OPTIONAL"] = "optional";
    Quantity["REQUIRED"] = "required";
})(Quantity || (Quantity = {}));
export var LookUp;
(function (LookUp) {
    LookUp["SELF"] = "self";
    LookUp["SKIP_SELF"] = "skipSelf";
})(LookUp || (LookUp = {}));
//# sourceMappingURL=types.js.map